import api from './api';
import { Client, ClientSearchResponse, QuickClientData, QuickDependentData } from '../types/client.types';

export const clientService = {
    searchByPhone: async (phone: string): Promise<ClientSearchResponse> => {
        const response = await api.get('/clients/search/', {
            params: { phone }
        });
        return response.data;
    },

    searchByName: async (name: string): Promise<ClientSearchResponse> => {
        const response = await api.get('/clients/search/', {
            params: { name }
        });
        return response.data;
    },

    quickCreate: async (data: QuickClientData): Promise<{ created: boolean; client: Client }> => {
        const response = await api.post('/clients/quick_create/', data);
        return response.data;
    },

    quickCreateDependent: async (data: QuickDependentData): Promise<{ created: boolean; dependent: any }> => {
        const response = await api.post('/dependents/quick_create/', data);
        return response.data;
    }
};

export default clientService;
